import { actionTypes, browserCategories } from './constants';
import { apiCallStatus } from 'helpers/constants';

const initialState = {
    selectedAsset: null,
    selectedAssetCapability: {
        loadingStatus: null,
        data: null
    },
    subscriptionInfo: {
        loadingStatus: null,
        data: null,
        error: null
    },
    kpiList: {
        loadingStatus: null,
        kpis: [],
        error: null
    },
    offGraphSignals: [],
    assetKPILists: [],
    selectedCategory: browserCategories.POWERTRAINS,
    selectedPowertrainId: null,
    powertrainList: {
        loadingStatus: null,
        data: [],
        error: null
    }
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CLEAR_STORE:
        case actionTypes.SET_SELECTED_FILTERS:
            return { ...initialState };

        case actionTypes.ON_GRAPH_CLEAR_STORE:
            return { ...initialState, offGraphSignals: state.offGraphSignals };

        case actionTypes.SET_SELECTED_ASSET:
            return {
                ...state,
                selectedAsset: action.asset
            };

        case actionTypes.CLEAR_KPI_LIST:
            return {
                ...state,
                kpiList: { ...initialState.kpiList }
            };

        case actionTypes.SET_BROWSER_CATEGORY:
            return {
                ...state,
                selectedCategory: action.category
            };

        case actionTypes.SET_SELECTED_POWERTRAIN_ID:
            return {
                ...state,
                selectedPowertrainId: action.powertrainId
            };

        case actionTypes.GET_POWERTRAIN_LIST_FOR_BROWSER:
            return {
                ...state,
                powertrainList: {
                    loadingStatus: action.loadingStatus,
                    data: action.loadingStatus === apiCallStatus.SUCCESS ? action.data || [] : state.powertrainList.data,
                    error: action.error || null
                }
            };

        case actionTypes.ADD_OFF_GRAPH_SIGNAL: {
            if (!action.signal?.key) {
                return state;
            }
            if (state.offGraphSignals.some((item) => item?.key === action.signal.key)) {
                return state;
            }
            return {
                ...state,
                offGraphSignals: [...state.offGraphSignals, action.signal]
            };
        }

        case actionTypes.REMOVE_OFF_GRAPH_SIGNAL:
            return {
                ...state,
                offGraphSignals: state.offGraphSignals.filter((item) => item?.key !== action.key)
            };

        case actionTypes.CLEAR_OFF_GRAPH_SIGNALS:
            return {
                ...state,
                offGraphSignals: action.tabPrefix
                    ? state.offGraphSignals.filter((item) => !item?.key?.startsWith(`${action.tabPrefix}|`))
                    : []
            };

        case actionTypes.GET_ASSET_CAPABILITY:
            return {
                ...state,
                selectedAssetCapability: {
                    loadingStatus: action.loadingStatus,
                    data: action.loadingStatus === apiCallStatus.SUCCESS ? action.data : state.selectedAssetCapability.data,
                    error: action.error || null
                }
            };

        case actionTypes.GET_ASSET_SUBSCRIPTION:
            return {
                ...state,
                subscriptionInfo: {
                    loadingStatus: action.loadingStatus,
                    data: action.loadingStatus === apiCallStatus.SUCCESS ? action.data : state.subscriptionInfo.data,
                    error: action.error || null
                }
            };

        case actionTypes.GET_KPIS_FOR_KPI_TYPE:
            return {
                ...state,
                kpiList: {
                    loadingStatus: action.loadingStatus,
                    kpis: action.loadingStatus === apiCallStatus.SUCCESS ? action.data || [] : state.kpiList.kpis,
                    error: action.error || null
                }
            };

        default:
            return state;
    }
};
